import React, { Component } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import onlineBanner from 'assets/images/wh-online-logo.svg';
import BannerCarousel from './BannerCarousel';
import Button from '../../../components/common/Button';
import FormMessage from '../../FormMessage';
import Preloader from '../../../components/common/Preloader';
import Translation from '../../i18n/Translation';
import getSlider from '../../../utils/bannersScheduling';
import { ADD_BETSLIP, BETTING_BUDDY, LIVE_SCORES, OMNI_WITHDRAW, OPEN_BETS, SAVED_SLIPS, SETTLED_BETS } from '../../../routes/paths';
import { accountDetailsRequest } from '../../../modules/account/actions';
import { getHomepageSliderDuration } from '../../../modules/cms/selectors';
import { hasSavedSlips, isDetailsPending, isOmniLinked, mustLoadSettings } from '../../../modules/account/selectors';
import { isAuthenticated } from '../../../modules/user/selectors';
import { link, openOnlineLinkModal, openSportsPage } from '../../../modules/analytics/actions';
import { open } from '../../../modules/modal/actions';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { homeBannerImageUrls } = contentStackImageUrls;

export class Home extends Component {
  componentWillMount() {
    const { mustLoadAccountSettings, loadAccountSettings } = this.props;
    if (mustLoadAccountSettings) {
      loadAccountSettings();
    }
  }

  createButtonsSection() {
    const { authenticated, omniLinked, showSavedSlips, openLoginModal, openRegistrationModal } = this.props;

    const openLink = (path, name) => {
      const { clickLink, history } = this.props;

      clickLink({
        source: 'Home',
        path,
        name
      });
      history.push(path);
    };

    const buttons = [
      {
        action: () => openLink(BETTING_BUDDY, 'CreateASlip'),
        condition: true,
        text: 'Create a Slip'
      },
      {
        action: () => openLink(SAVED_SLIPS, 'SavedSlips'),
        condition: !!showSavedSlips,
        text: 'Saved Slips'
      },
      {
        action: () => openLink(OPEN_BETS, 'OpenBets'),
        condition: true,
        text: 'Open Bets'
      },
      {
        action: () => openLink(SETTLED_BETS, 'SettledBets'),
        condition: true,
        text: 'Settled Bets'
      },
      {
        action: () => openLink(ADD_BETSLIP, 'AddBet'),
        condition: true,
        text: 'Add Bet'
      },
      {
        action: () => openLink(OMNI_WITHDRAW, 'Withdraw'),
        condition: authenticated && omniLinked,
        text: 'Withdraw'
      },
      {
        action: openLoginModal,
        condition: authenticated && !omniLinked,
        text: 'Link Account',
        colourClass: 'electric-blue'
      },
      {
        action: openRegistrationModal,
        condition: authenticated && !omniLinked,
        text: 'Register',
        colourClass: 'electric-blue'
      },
      {
        action: () => openLink(LIVE_SCORES, 'LiveScores'),
        condition: true,
        text: 'Live Scores'
      }
    ];

    const buttonsToDisplay = buttons.filter(button => button.condition);

    const chunk = (chunks, el, i) => (
      ((i % 2) ? chunks[chunks.length - 1].push(el) : chunks.push([el])) && chunks
    );
    const buttonsDisplayStructure = buttonsToDisplay.reduce(chunk, []);

    return (
      <div className="home-nav">
        {buttonsDisplayStructure
          .map(row => (
            <div className="home-nav__row" key={`row-${row[0].text}`}>
              {row.map(button => (
                <Button
                  className={`home-nav__button ${button.colourClass}`}
                  onClick={button.action}
                  key={button.text}
                >
                  {button.text}
                </Button>
              ))}
            </div>
          ))}
      </div>
    );
  }

  render() {
    const { checkingState, openSportsbook, authenticated, omniLinked } = this.props;

    if (checkingState) {
      return (
        <div className="with-omni">
          <div className="with-omni__preloader">
            <Preloader>
              <Translation section="linkingAccounts" label="checking" />
            </Preloader>
          </div>
        </div>
      );
    }

    // TODO hard coding these for now, until the banners config is moved from CEMS to Content Stack
    const { plusRegister, plusLinkAccount1, plusLinkAccount2, plusLinkAccount3, onlineBannerBg } = homeBannerImageUrls;
    const slideDuration = 10;
    const hardCodedBanners = Immutable.List([
      {
        image: plusLinkAccount1,
        backUp: '../../../../assets/images/banners/link-account-1.png',
        ctaButtonText: 'GET STARTED',
        ctaUrl: 'showLogin',
      },
      {
        image: plusLinkAccount2,
        backUp: '../../../../assets/images/banners/link-account-2.png',
        ctaButtonText: 'GET STARTED',
        ctaUrl: 'showLogin',
      },
      {
        image: plusLinkAccount3,
        backUp: '../../../../assets/images/banners/link-account-3.png',
        ctaButtonText: 'GET STARTED',
        ctaUrl: 'showLogin',
      },
      {
        image: plusRegister,
        backUp: '../../../../assets/images/banners/register.png',
        ctaButtonText: 'SIGN UP TODAY',
        ctaUrl: 'showRegistration',
        ctaButtonBackgroundColor: '#00143c',
        backgroundColor: '#00ace9'
      },
    ]);

    return (
      <div className="home">
        <div className="container--fixed">
          <FormMessage className="home__message" slotId="default" />
          <div className="home-section">
            {this.createButtonsSection()}
            <div className="home-section__row">
              <a
                className="home-online-banner"
                href="https://sports.williamhill.com/betting/en-gb"
                target="_blank"
                rel="noopener noreferrer"
                onClick={openSportsbook}
              >
                <img
                  className="home-online-banner__background"
                  src={onlineBannerBg}
                  onError={(e) => { e.target.src = '../../../../assets/images/banners/online-banner-bg.png'; }}
                />
                <img className="home-online-banner__logo" src={onlineBanner} width="100%" />
                <span className="home-online-banner__button">Bet Now</span>
              </a>
            </div>
            {authenticated && !omniLinked
              && (
              <div className="home-banner-carousel">
                <BannerCarousel banners={hardCodedBanners} duration={slideDuration} />
              </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  authenticated: PropTypes.bool,
  checkingState: PropTypes.bool,
  omniLinked: PropTypes.bool,
  mustLoadAccountSettings: PropTypes.bool,
  loadAccountSettings: PropTypes.func.isRequired,
  openSportsbook: PropTypes.func.isRequired,
  clickLink: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  showSavedSlips: PropTypes.bool,
  openLoginModal: PropTypes.func.isRequired,
  openRegistrationModal: PropTypes.func.isRequired
};

Home.defaultProps = {
  showSavedSlips: false
};

const mapStateToProps = state => ({
  mustLoadAccountSettings: mustLoadSettings(state),
  authenticated: isAuthenticated(state),
  checkingState: isDetailsPending(state),
  omniLinked: isOmniLinked(state),
  showSavedSlips: hasSavedSlips(state),
  slider: getSlider(state),
  slideDuration: getHomepageSliderDuration(state)
});

const mapDispatchToProps = {
  loadAccountSettings: accountDetailsRequest,
  openSportsbook: openSportsPage,
  clickLink: link,
  openLoginModal: open.bind(null, {
    componentName: 'LinkAccountTerms',
    componentProps: {
      contentToDisplay: 'login'
    }
  }),
  openRegistrationModal: open.bind(null, {
    componentName: 'LinkAccountTerms',
    componentProps: {
      contentToDisplay: 'registration'
    }
  }),
  analyticsAction: openOnlineLinkModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
